import { makeStyles } from '@material-ui/core';

export const workOrderLinkedTicketsStyles = makeStyles(theme => ({
    linkedTicketsRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    label: {
        color: theme.palette.text.secondary,
        fontSize: 13,
        whiteSpace: 'nowrap',
    },
    pill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        padding: `${theme.spacing(0.25)}px ${theme.spacing(1.25)}px`,
        border: `1px solid ${theme.palette.primary.light}`,
        borderRadius: 20,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: theme.transitions.create(['background-color', 'border-color']),
        '&:hover, &:focus-visible': {
            backgroundColor: theme.palette.action.hover,
            borderColor: theme.palette.primary.main,
        },
    },
    pillIcon: {
        fontSize: 15,
    },
    emptyState: {
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
        fontSize: 13,
    },
}));
